const defaultUrl = 'https://images.delfi.lt/media-api-image-cropper/v1';
const defaultExtension = 'jpg';

type BuildPictureUrlArguments = { url?: string; id: string; extension?: string };

export default function buildPictureUrl({ id, url = defaultUrl, extension = defaultExtension }: BuildPictureUrlArguments) {
  return `${url}/${id}.${extension}?noup&w=1287`;
}
